// Modules
import React, { Component, Fragment } from "react";

// Styles
import "./Day.scss"

// Interfaces
import {Tip} from "Interfaces/TipInterface";

// Components
import ToolTip from "../../ToolTip";

interface IProps {
    day:Date;
    onClick(date:Date):void;
    activeDate: Date | null;
    dayEnabled: boolean;
    tooltip?: Tip[];
    dayOutsideWindow: boolean;
}

interface IState {

}

class Day extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.selectDateOnEnter = this.selectDateOnEnter.bind(this)
    }

    isDateToday(date:Date):boolean {
        let today = new Date();
        return this.datesEqual(date, today);
    }

    datesEqual(date1:Date, date2:Date):boolean {
        if(date1.getDate() === date2.getDate() &&
           date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() ) {
               return true;
           } else {
               return false;
           }
    }

    stripTime(date:Date):Date {
        return new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`);
    }

    getClassList():string[] {
        let classList = ["day"];

        if(this.props.dayEnabled) {
            classList.push("enabled");
        }

        if(this.props.dayOutsideWindow) {
            classList.push("outside-window");
        }

        if (this.props.dayEnabled &&
            this.props.activeDate !== null &&
            this.props.activeDate.valueOf() === this.props.day.valueOf()) {
          classList.push("active");
        }
        return classList;
    }

  	selectDateOnEnter(event: KeyboardEvent) {
  		if (event.keyCode === 13) {
  			this.props.onClick(this.props.day);
  		} else {
  		  return
  		}
  	}

    onClick() {
      if(this.props.dayEnabled) {
        this.props.onClick(this.props.day);
      }

      //Had to comment out the code above to make the unavailable days clickable and also make the days outside booking window unclickable
      // if(!this.props.dayOutsideWindow) {
      //   this.props.onClick(this.props.day);
      // }
    }

    render() {
        const {tooltip} = this.props;
        
        return (
          <div className="day-container">
            <ToolTip
                useRefToPosition={false}
                tabIndex={-1}
                tip={tooltip ? tooltip : []}
                disabled={!this.props.dayEnabled}
                id={`day-container-${this.props.day.toString()}`}
            >
                <button
                  aria-label={this.props.day.toDateString()}
                  className={this.getClassList().join(" ")}
                  onClick={this.onClick}
                  onKeyDown={(event)=>this.selectDateOnEnter}
                  tabIndex={this.props.dayEnabled ? 0 : -1}
                >
                    <span className="date">{this.props.day.getDate()}</span>
                </button>
            </ToolTip>
          </div>
        );
    }
}

export default Day;
